<div class="dashbord-grid-wraper">
  

  <div class="location-data">
    @if (isGridView) {
    <div class="card-collection">
      @for (item of tableArr; track item) {
      <!-- <div class="col-md-4"> -->
      <div class="dp-card">
        <span class="card-title">{{ item.state }}</span>
        <table style="width: 100%">
          <tbody>
            <tr>
              <td class="card-text-left">Active</td>
              <td class="card-text-right">{{ item.active }}</td>
            </tr>
            <tr>
              <td class="card-text-left">Inactive</td>
              <td class="card-text-right">{{ item.inactive }}</td>
            </tr>
            <tr>
              <td class="card-text-left">Defaulter</td>
              <td class="card-text-right">{{ item.defaulter }}</td>
            </tr>
            <tr>
              <td class="card-text-left">Stagnant</td>
              <td class="card-text-right">{{ item.stagnant }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- </div>   -->
      }
    </div>
    } @else {
    <div class="list-view">
        <dp-table
          [displayedColumns]="displayColumnData"
          [dataTable]="tableArr"
          [componentMap]="cellComponentMap"
        ></dp-table>
    </div>
    }
  </div>
</div>
